<template>
    <div>
        <div class="uploader">
            <input type="file" class="avatar-uploader" :id="id" :url="url" :multiple="multiple" @change="doUploade">
            <img v-if="url!= ''||imgUrl!=''" :src="url=imgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </div>
    </div>
</template>

<script>
    const OSS = require('ali-oss')
    const co = require('co')
    export default {
        name:'uploader',
        props: {
            multiple: {
                type: Boolean,
                twoWay: false
            },
            id: {
                type: String,
                twoWay: false,
            },
            urls: {
                type: Array,
                twoWay: true
            },
            imgs:{
                type: Array,
                twoWay: true
            },
            imgUrl:String
        },
        data () {
            return {
                region: 'oss-cn-beijing',//'cn-beijing',//
                bucket: 't-group-consultation', //文件夹名
                url: ''
            }
        },
        mounted(){
            // this.url=imgUrl;
        },
        methods: {
            doUploade () {
                var _this = this
                this.$http.get(IP+'/sts',{})
                .then( res => {
                    let client = new OSS({
                        region: _this.region,
                        accessKeyId: res.data.data.accesskeyid,
                        accessKeySecret: res.data.data.accesskeysecret,
                        stsToken: res.data.data.securitytoken,
                        bucket: _this.bucket
                    })
                    var files = document.getElementById(this.id)
                    console.log(client)
                    if(files.files) {
                        var fileLen = files.files
                        for (let i = 0; i < fileLen.length; i++) {
                            var file = fileLen[i]
                            // var storeAs =file.name
                            var storeAs ='image/'+getAllDate()+'/'+getUUID()+'.jpg';
                            co(function* () {
                                var result = yield client.multipartUpload(storeAs, file)
                                
                                if(result.res) {
                                    var url = client.signatureUrl(storeAs);
                                    _this.url = url;
                                    _this.$emit('updateUrls','https://t-group-consultation.oss-cn-beijing.aliyuncs.com/'+storeAs + '?' + 'x-oss-process=style/mystyle')
                                    _this.$emit('updateImg', 'https://t-group-consultation.oss-cn-beijing.aliyuncs.com/'+storeAs + '?' + 'x-oss-process=style/mystyle')
                                } 
                            }).catch(function (err) {
                                console.log(err);
                            });
                        }
                    }
                })
            }
        }
    }
</script>

<style>
.uploader{
    text-align: left;
}
.avatar-uploader {
    width: 80px;
    height: 80px;
    border: 1px solid #409EFF;
    border-color: #409EFF;
    opacity: 0;
    /* top: 58px; */
    cursor: pointer;
    position: absolute;
    z-index: 10;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    cursor: pointer;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    position: relative;
}
.avatar {
    width: 80px;
    height: 80px;
    display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/upLoad.vue